import list from './ProductBrochure'export default list